import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crown } from "lucide-react";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-mahogany-900">
    <Crown size={40} className="text-gold animate-pulse" strokeWidth={1} />
  </div>
);

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to={admin ? "/admin-login" : "/login"} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

export default ProtectedRoute;
